export const roles = {
    admin: 'admin',
    parent_user: 'parent_user'
};

export const BRAND_NAME = "$ocialcred$";
export const BRAND_NAME_UPPER = "$OCIALCRED$";
export const BRAND_MEMBER = "$ocialcredder";
export const BRAND_MEMBERS = "$ocialcredders";

export const brandConstants = {
    name: BRAND_NAME,
    nameUpper: BRAND_NAME_UPPER,
    member: BRAND_MEMBER,
    members: BRAND_MEMBERS,
};
